import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';
//import { CookieService } from 'ngx-cookie-service/lib/cookie.service';
import { CookieService } from 'ngx-cookie-service'
//import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal';
import { Subject } from 'rxjs';
import { AlertService, Dialog } from '../alert.service';
import { APIService } from '../api.service';
import { DataService } from '../data.service';
import { FunctionService } from '../function.service';
import { AnEvent, Entry, Player } from '../Main.Model';
import { Router } from '@angular/router';
//import { ModalWindowComponent } from '../modal/Modal-Window.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    animations: [
        trigger('reg', [
            state('small', style({
                opacity: 0,
                transform: 'translateX(0)'
            })),
            state('big', style({
                'background-color': 'lime',
                opacity: 1,
                transform: 'translateX(400px)'
            })),
            transition('small <=> big', animate(1000))
        ])
    ],
    standalone: false
})

export class LoginComponent implements OnInit {

  filterargs = {password: ''};
  state = 'small';
  Note: String = "";
  ShowRegister: boolean = false;
  showRecover!: boolean;
  newUser: Player;
  LoginEmail!: string;
  LoginPassword!: string;
  APlayerHasBeenSelected!: boolean;
  SaveChanges!: boolean;
  //@Input() OKEmit: Dialog;
  OKPressed: Subject<Dialog>;
  YESPressed: Subject<Dialog>;
  //NOPressed: Subject<Dialog>;
  //DataService.CurrentUser: Player = new Player();//user being edited
  private LoginCookie!: string;

  constructor(public DataService: DataService, private APIService: APIService, private AlertService: AlertService, 
    private FunctionService: FunctionService, private cookieService: CookieService, private router: Router) { 
    this.newUser = new Player();
    this.OKPressed = this.AlertService.OKPressed;
    this.YESPressed = this.AlertService.YESPressed;
  }

  async ngOnInit() {
    this.OKPressed.subscribe( data => {
      this.OKButtonPressedOnDialog(data);
    })
    this.YESPressed.subscribe( data => {
      this.YESButtonPressedOnDialog(data);
    })
    if (this.DataService.MainStatus == 'NewUser') {
      this.ShowRegister = true;
      this.newUser = this.FunctionService.getNewUser();
    }
    if (this.DataService.LoggedInUser.name == 'Login') {
      await this.DataService.LogUserInFromCookie();
    }
    if (!this.DataService.CurrentUser.name) {
      this.DataService.CurrentUser = this.DataService.LoggedInUser;
    }
  }

  filterPlayer(player: Player) {
    return player.password == null
  }

  async OKButtonPressedOnDialog(DialogData: Dialog) {
    if (DialogData.title == 'Change Password') {
      if (this.DataService.LoggedInUser.id > 0 && DialogData.InputResponses[0] != '' && DialogData.InputResponses[1] != '') {
        var Success = "";
        Success = await this.APIService.ChangePassword(this.DataService.LoggedInUser.id, DialogData.InputResponses[0], DialogData.InputResponses[1]);
        if (Success == 'Success') {
            this.showTempMessage("your Password has been Changed ):");
        } else {
          //this.AlertService.showSimpleAlert("Password not changed " + Success);//there is an issue when an alert and dialog are showing....1 wins....
          this.showTempMessage("your Password has not been Changed ):");
        }
      } else {
        this.showTempMessage("Password not changed as you must enter an old & new password");
        //this.AlertService.showSimpleAlert("Password not changed as you must enter an old & new password");
      }
    }
  }

  async YESButtonPressedOnDialog(DialogData: Dialog) {
    if (DialogData.title == 'Recover Password') {
      var Message = '';
      document.body.style.cursor = "wait";
      var Result = await this.APIService.RecoverPassword(this.DataService.EmailToRecover);
      if (Result.indexOf('Success') > -1 && Result.indexOf("Email Sent") > -1) {
        Message = "Your password has been reset";
      } else {
          Message = Result;
      }
      this.showTempMessage(Message);
      //this.ShowMessage("PassNote", Message)
      this.showRecover = false;
      //this.ReloadPlayers();
      this.DataService.EmailToRecover = '';
      document.body.style.cursor = "pointer"
    }
  }

  async Login () {//need to know when more than 1 of these emails are in use...
    if (this.LoginEmail != '' && this.LoginPassword != '') {
      //var boolFound = false;
      //need to populate torns & matches because they will be needed later
      this.DataService.refreshTorns();
      this.DataService.refreshMatches();
      this.DataService.LoggedInUser = await this.APIService.Authenticate(this.LoginEmail, this.LoginPassword);
      if (this.DataService.LoggedInUser.name) {
        this.DataService.CurrentUser = this.DataService.LoggedInUser;
        //CookieExpiry = CookieExpiry.addDays(7);//Cookie expires in 7 days
        //this.SetLoginCookie();
        this.cookieService.set('Login-Cookie', this.DataService.LoggedInUser.id.toString(), this.FunctionService.addDays(7, new Date()));
        this.DataService.SaveState();
        this.FunctionService.checkToSeeIfLoggedInUserIsInSelectedTorn();
        this.FunctionService.WhichTornsIsLoggedInUserIn();
        this.FunctionService.ShouldWeAllowUpdate();
        this.router.navigate(['/home']);//navigate to home page:
        //await this.APIService.GetUserIp(this.DataService.LoggedInUser.name, this.DataService.SelectedTorn);
      } else {
        //this.AlertService.showSimpleAlert("Password Incorrect");
        this.showTempMessage("wrong password!!!");//actually , we don't know that, they may not exist at all - need to know....
        this.showRecover = true;
      }
    } else {
      this.showTempMessage("Email & Password can not be blank");
      //need to know if Email not found in DB
    }
  }

  Logout() {
    this.DataService.LoggedInUser = new Player();
    this.DataService.LoggedInUser.accessLevel = 0;
    this.DataService.LoggedInUser.name = "Login";
    this.cookieService.delete('Login-Cookie');
    this.DataService.LoggedInUserAlreadyEnteredInTorn = false;
    //this.LoggedInUserID = 0;
    //this.ShouldWeAllowUpdate();
    this.DataService.SaveState();
  }

  Register() {
    this.newUser = this.FunctionService.getNewUser();
    this.DataService.changeMainStatus('NewUser');
    this.ShowRegister = true;
    this.newUser.email = this.LoginEmail;//email.value;
    //this.APIService.test();
  }

  OK() {
    var test = true;
  }

  RecoverPW() {
    //this.RRshowScoreHover = false;
    //this.RRshowScoreHover2 = false;
    this.DataService.EmailToRecover = this.LoginEmail;
    this.AlertService.showDialog('Recover Password','YesNo', [] as string[], "Would you like to reset your password via email?", "Standard");
  }

  ChangePassword() {
    var inputsList = [];
    inputsList.push("Old Password");
    inputsList.push("New Password");
    this.AlertService.showDialog('Change Password','OKCancel', inputsList, "change password", "Standard");
  }

  updateEntry(entry: Entry) {
    var EntryToBeUpdated = entry;
    EntryToBeUpdated.events = "";//will be storing in DB as string
    entry.eventsList.forEach(event => {
      EntryToBeUpdated.events += event.id + ",";
    });
    EntryToBeUpdated.events = "";
    this.APIService.updateEntry(EntryToBeUpdated);
  }

  async SaveUserDetails(theUser: Player) {
    await this.FunctionService.CalcAPlayersRankingData(theUser,"Zero");
    if (this.DataService.SelectedTorn) {
        for (var e = 0; e < this.DataService.SelectedTorn.entries.length; e++) {
            var TheEntry = this.DataService.SelectedTorn.entries[e];
            if (TheEntry.playerId == theUser.id) {
                TheEntry.name = theUser.name;
                TheEntry.phone = theUser.phone;
                TheEntry.province = theUser.province;
                TheEntry.country = theUser.country;
                TheEntry.ttGrade = theUser.tableTennis / 10;
                TheEntry.badGrade = theUser.badminton / 10;
                TheEntry.sqGrade = theUser.squash / 10;
                TheEntry.tennisGrade = theUser.tennis / 10;
                TheEntry.singlesPoints = theUser.singlesPoints;
                TheEntry.doublesPoints = theUser.doublesPoints;
                //this.FunctionService.BuildEntryEvents(TheEntry);
                this.APIService.updateEntry(TheEntry);
            }
        }
        this.FunctionService.getDetailsFromEntry();//then redo the player lists - also need to update entries....!!!
    }
    //update player startpoints if they have never played a match
    if ((theUser.singlesMatchesPlayed + theUser.doublesMatchesPlayed) === 0 || theUser.gradingReviewed == false) {
        if (theUser.gender == "M") {
          theUser.singlesPoints = (theUser.tableTennis + theUser.badminton + theUser.squash + theUser.tennis) * 20;
          theUser.doublesPoints = (theUser.tableTennis + theUser.badminton + theUser.squash + theUser.tennis) * 20;
        } else {
          theUser.singlesPoints = (theUser.tableTennis + theUser.badminton + theUser.squash + theUser.tennis) * 18;
            theUser.doublesPoints = (theUser.tableTennis + theUser.badminton + theUser.squash + theUser.tennis) * 18;
        }
    }
    //user.GradingReviewed = true;
    //this.SaveChanges = false;
  if (this.newUser.name) {
     this.newUser.BadRating = 0;
     this.newUser.TRating = 0;
     this.newUser.SqRating = 0;
     this.newUser.TTRating = 0;
     this.newUser.DOB = undefined;
     this.newUser.password = "";
    await this.APIService.updatePlayer(this.newUser);
  } else {
    //theUser.dob = new Date(theUser.dob.toString());
    await this.APIService.updatePlayer(theUser);
    this.SaveChanges = false;
  }
    //if (Success == true) {
      this.FunctionService.CalcAPlayersRankingData(this.DataService.LoggedInUser, 'Zero');
    //}
    //
  }

  CancelRegister() {
    this.ShowRegister = false;
    //this.animate();
  }

  async RegisterUserDetails() {
    var isNewUser = false;
    this.newUser.gradingReviewed = false;

    if (this.APlayerHasBeenSelected == true) {//if a player has been selected who is already in the DB
      
      this.APlayerHasBeenSelected = false;
      this.DataService.LoggedInUser = this.newUser;
      this.SaveUserDetails(this.newUser);//save user to DB
      if (this.newUser.password != '') {
        this.showTempMessage("You are now logged in and can login and enter tournaments");
      }
    } else {
      isNewUser = true;
    }
        if (isNewUser == true) {
        if (this.newUser.name != 'BYE') {
            if (this.newUser.gender == "M") {
                this.newUser.singlesPoints = (+this.newUser.tableTennis + +this.newUser.badminton + +this.newUser.squash + +this.newUser.tennis) * 20;
            } else {
                this.newUser.singlesPoints = (+this.newUser.tableTennis + +this.newUser.badminton + +this.newUser.squash + +this.newUser.tennis) * 18;
            }
            this.newUser.doublesPoints = this.newUser.singlesPoints
        }
        if (this.DataService.MainStatus != 'NewUser') {
            this.showTempMessage("Now you can login using your email & password");
            //this.ShowMessage("RegNote", "Now you can login using your email & password");
            this.LoginEmail = this.newUser.email;
        }
        //await this.APIService.GetUserIp(this.DataService.LoggedInUser.name, this.DataService.SelectedTorn);
        this.newUser.id = await this.APIService.createNewUser(this.newUser);
        if (this.newUser.id  > 0) {
            this.DataService.Players.push(this.newUser);
            if (this.DataService.MainStatus == 'NewUser') {
              if (this.DataService.SelectedTorn) {
                this.FunctionService.createEntryForPlayer(this.newUser);//needs to happen here once newuser id established
                this.DataService.changeMainStatus('Torns');
                this.DataService.changeTornStatus('EditEntries');
              }
            }
            //this.DataService.LoggedInUser = this.newUser;//don't log them in yet
            if (this.newUser.email != '' && this.newUser.password != '') {
              this.showTempMessage("You are now registered and can login and enter tournaments");
                //this.ShowMessage("PassNote", "You are now registered and can login and enter tournaments");
            } else {
              this.showTempMessage("user is now registered - please email the tournament director to enter this user in a tournament");
                //this.ShowMessage("PassNote", "user is now registered - please email the tournament director to enter this user in a tournament");
            }
        }
    }
    this.ShowRegister = false;
  }

  animate() {
    this.state == 'small' ? this.state = 'big' : this.state = 'small';
  }

  showTempMessage(message: string) {
    this.Note = message;
    this.animate();
    setTimeout(() => {//fades back in??
      this.animate();
    }, 3000);
  }

  // createEntryForPlayer(ThePlayer: Player) {
  //   var newEntry = {
  //     dateOfEntry: new Date(),
  //     name: ThePlayer.name,
  //     province: ThePlayer.province,
  //     singles: false,
  //     doublesMixed: false,
  //     partner: "",
  //     gender: ThePlayer.gender,
  //     country: ThePlayer.country,
  //     email: ThePlayer.email,
  //     phone: ThePlayer.phone,
  //     tornament: this.DataService.SelectedTorn ? this.DataService.SelectedTorn.id : 0,
  //     playerId: ThePlayer.id,
  //     partnerId: 0,
  //     partnerReq: false,
  //     ttGrade: ThePlayer.tableTennis / 10,
  //     badGrade: ThePlayer.badminton / 10,
  //     sqGrade: ThePlayer.squash / 10,
  //     tennisGrade: ThePlayer.tennis / 10,
  //     feesPaid: false,
  //     comments: '',
  //     gradePrefer: 0,
  //     fee: 0,
  //     singlesPoints: 0,
  //     doublesPoints: 0,
  //     id: 0,
  //     events: "",
  //     eventsList: [] as AnEvent[],
  //     SendAnnouncement: false,
  //     team: 0,
  //     YearsOld: 0
  //   }

  //   if (newEntry.gender == "M") {
  //       newEntry.singlesPoints = (ThePlayer.tableTennis + ThePlayer.badminton + ThePlayer.squash + ThePlayer.tennis) * 20;
  //       newEntry.doublesPoints = (ThePlayer.tableTennis + ThePlayer.badminton + ThePlayer.squash + ThePlayer.tennis) * 20;
  //   } else {
  //       newEntry.singlesPoints = (ThePlayer.tableTennis + ThePlayer.badminton + ThePlayer.squash + ThePlayer.tennis) * 18;
  //       newEntry.doublesPoints = (ThePlayer.tableTennis + ThePlayer.badminton + ThePlayer.squash + ThePlayer.tennis) * 18;
  //   }
  //   this.DataService.SelectedTorn.entries.unshift(newEntry);
    
  //   this.addNewEntry(newEntry, false, this.DataService.SelectedTorn.discount);
  //   this.DataService.SaveState();
  // }

  async addNewEntry(newEntry: Entry, EmailPlayer: boolean, discount: number) {
    //calculate discount here?
    newEntry.id = await this.APIService.createNewEntry(newEntry);
    if (newEntry.id > 0) {
      if (EmailPlayer == true) {
          alert("Thank you for your entry, an email has been sent with the account details for the fees");
      }
      this.FunctionService.getDetailsFromEntry();
    } else if (EmailPlayer == true) {
      alert("there was a problem sending a confirmation email, please contact Tournament director for bank account details")
    }
  }

  PlayerSelected() {
    this.APlayerHasBeenSelected = true;
    var SubmitButton = document.getElementById("btnSubmitNewUser")!;
    SubmitButton.innerHTML = "Update Database entry";
    //var user = this.DataService.Players[document.getElementById("PlayerList").selectedIndex];
    // if (!user.Email && !user.Phone && !user.Password) {
    //     var tempEmail = this.newUser.email;
    //     this.newUser = this.DataService.Players[document.getElementById("PlayerList").selectedIndex];
    //     this.newUser.email = tempEmail;
    // }
  }

}
